module.exports = __webpack_public_path__ + "067fb94f35e91c9f6d848dc879f5da66.pdf";